import {
  CalendarTemplateBuilderModelMulti,
  DbTemplateBuilderModelMulti,
  DetailTemplateBuilderModelMulti,
  HegTemplateBuilderModelMulti,
  ItemTemplateBuilderModelMulti,
  NotificationTemplateBuilderModelMulti,
  OverviewTemplateBuilderModelMulti,
  PTemplateBuilderModelWithPItems,
  TemplateBuilderModelsThatCanHaveDetail,
  TemplateBuilderModelsWithFunctions,
  TemplateBuilderModelsWithPresentationModel,
  TemplateBuilderModelsWithStandardDataModel,
  TemplatesRepresentedAsATable,
  TemplatesWithTitle,
  TopLevelTemplateBuilderModels,
} from "./templateBuilderModelGroupTypes";
import {
  AllTemplateBuilderModels,
  HWRTemplateBuilderModel,
  MultiDetailTemplateBuilderModel,
  ReportingServicesTemplateBuilderModel,
} from "../../requests/templateBuilder/types";
import { CollapseUnion, TemplateType } from "../../globalTypes";
import { isNumber } from "../../utils/generalUtils";

export const createGuard =
  <T extends AllTemplateBuilderModels>(
    predicate: (model: CollapseUnion<AllTemplateBuilderModels>) => boolean
  ) =>
  (model: AllTemplateBuilderModels): model is T =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    predicate(model as any);

export const isOverview = createGuard<OverviewTemplateBuilderModelMulti>(
  (model) => model.type === "overview"
);

export const isCalendar = createGuard<CalendarTemplateBuilderModelMulti>(
  (model) => model.type === "calendar"
);

export const isNotification =
  createGuard<NotificationTemplateBuilderModelMulti>(
    (model) => model.type === "notification"
  );

export const isDetail = createGuard<DetailTemplateBuilderModelMulti>(
  (model) => model.type === "detail"
);

export const isItem = createGuard<ItemTemplateBuilderModelMulti>(
  (model) => model.type === "item"
);

export const isMultiDetail = createGuard<MultiDetailTemplateBuilderModel>(
  (model) => model.type === "multiDetail"
);

export const isSsrs = createGuard<ReportingServicesTemplateBuilderModel>(
  (model) => model.type === "ssrs"
);

export const isDb = createGuard<DbTemplateBuilderModelMulti>(
  (model) => model.system === "db"
);

export const isHeg = createGuard<HegTemplateBuilderModelMulti>(
  (model) => model.system === "heg"
);

export const hwrTemplateTypes = [
  "hwrAdaptationPlan",
  "hwrAnnualEval",
  "hwrPersonalDevPlan",
  "hwrPotentialEval",
] as const;

export const isHwr = createGuard<HWRTemplateBuilderModel>((model) => {
  const array: readonly TemplateType[] = hwrTemplateTypes;
  return array.includes(model.type);
});

export const topLevelTemplateType = [
  "overview",
  "calendar",
  "ssrs",
  ...hwrTemplateTypes,
] as const;

export const isTopLevel = createGuard<TopLevelTemplateBuilderModels>(
  (model) => {
    const array: readonly TemplateType[] = topLevelTemplateType;
    return array.includes(model.type);
  }
);

export const hasPresentationModel =
  createGuard<TemplateBuilderModelsWithPresentationModel>(
    (model) => !!model.presentationTemplate
  );

export const hasPresentationTemplateItems =
  createGuard<PTemplateBuilderModelWithPItems>(
    (model) => !!model.presentationTemplate.items
  );

export const hasStandardDataModel =
  createGuard<TemplateBuilderModelsWithStandardDataModel>(
    // Tady by bylo idealni enumerovat vsechny to properties na DataTemplate iface,
    // ale bojim se, ze nektery muzou z BE prijit nullable a iface to nereflektuje
    (model) => isNumber(model.dataTemplate?.groupIdCounter)
  );

export const hasFunctions = createGuard<TemplateBuilderModelsWithFunctions>(
  (model) => Array.isArray(model?.dataTemplate?.functionItems)
);

export const templatesRepresentedAsTable = ["overview", "item", "calendar"];

export const isRepresentedAsATable = createGuard<TemplatesRepresentedAsATable>(
  (model) => templatesRepresentedAsTable.includes(model.type)
);

export const canHaveDetail =
  createGuard<TemplateBuilderModelsThatCanHaveDetail>(
    (model) =>
      model.dataTemplate.detailTemplateId !== undefined ||
      model.dataTemplate.detailTemplateId === null
  );

export const hasTitle = createGuard<TemplatesWithTitle>((model) =>
  ["notification", "calendar"].includes(model.type)
);
